import { Button, Group, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

type ExitConfirmProps = {
  onCancel: () => void;
  onQuit: () => void;
  onSaveAndQuit?: () => void;
};

export const ExitConfirm = ({ onCancel, onQuit, onSaveAndQuit }: ExitConfirmProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Text size="sm">{t(i18nKeys.AYS.EXIT_PAGE)}</Text>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={onCancel}>
          {t(i18nKeys.CANCEL)}
        </Button>
        {onSaveAndQuit && <Button onClick={onSaveAndQuit}>{t(i18nKeys.FORM.SAVE_AND_QUIT)}</Button>}
        <Button color={onSaveAndQuit ? 'red' : undefined} onClick={onQuit}>
          {t(onSaveAndQuit ? i18nKeys.FORM.QUIT_WITHOUT_SAVING : i18nKeys.CONFIRM)}
        </Button>
      </Group>
    </>
  );
};
